var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
export var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
// NOTE: Keep these in sync with citron.ts
var WARNING_ICONS = ['exclamation-', 'important', 'attention', 'cancelled', 'denied', 'flag', 'minus-circle', 'no'];
var icons = {
    up: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Ebold/chevron-up-bold%3C/title%3E%3Cpath fill='XXXXX' d='M63.998 30.18c.513 0 1.028.196 1.424.592l60.802 60.803c.784.783.786 2.05.009 2.828l-8.494 8.494c-.779.779-2.04.78-2.828-.009L64.003 51.981l-50.907 50.907a2.001 2.001 0 0 1-2.829.009l-8.493-8.494a1.995 1.995 0 0 1 .008-2.828l60.803-60.803c.393-.393.908-.59 1.422-.59z'  fill-rule='evenodd'/%3E%3C/svg%3E",
    down: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Ebold/chevron-down-bold%3C/title%3E%3Cpath fill='XXXXX' d='M63.998 97.82c.513 0 1.028-.196 1.424-.592l60.802-60.802c.784-.784.786-2.051.009-2.829l-8.494-8.493a1.995 1.995 0 0 0-2.828.008L64.003 76.019 13.096 25.112a2.001 2.001 0 0 0-2.829-.008l-8.493 8.493c-.78.779-.78 2.04.008 2.829l60.803 60.802c.393.393.908.59 1.422.59z'  fill-rule='evenodd'/%3E%3C/svg%3E",
};
export var alignCenter = {
    textAlign: 'center',
};
export var alignLeft = {
    textAlign: 'left',
};
export var alignRight = {
    textAlign: 'right',
};
export var actionAreaContainer = (_a = {
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1
    },
    _a["@media ".concat(mobile(1024))] = {
        marginBottom: 16,
    },
    _a);
export var container = reset;
export var divider = {
    borderRight: '2px solid #cccccc',
    paddingRight: 32,
};
export var dividerBefore = {
    paddingLeft: 32,
};
export var editing = {
    boxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.2)',
    transform: 'translateZ(1px)',
    '> tr': {
        transform: 'translateZ(1px)',
    },
};
export var truncate = function (width) { return ({
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: width,
}); };
export var inputDisabled = {
    cursor: 'not-allowed',
};
export var upperToolbar = (_b = {
        alignItems: 'center',
        display: 'flex',
        marginTop: 16,
        paddingBottom: 16
    },
    _b["@media ".concat(mobile(1024))] = {
        display: 'block',
    },
    _b);
export var footerToolbar = __assign(__assign({}, upperToolbar), { marginTop: 0, paddingBottom: 0, padding: "".concat(16, "px 0") });
export var selectedCountContainer = {
    paddingLeft: 16,
};
export var selectedCountContainerDisabled = __assign(__assign({}, selectedCountContainer), { color: "".concat('#cccccc', " !important") });
export var sortWrapperAsc = {
    ':after': __assign(__assign({}, getIcon(icons.up, 16, '#666666')), { content: '""', cursor: 'pointer', marginBottom: -2, marginLeft: 8 }),
};
export var sortWrapperAscDisabled = {
    ':after': __assign(__assign(__assign({}, sortWrapperAsc[':after']), getIcon(icons.up, 16, '#cccccc')), { cursor: 'not-allowed' }),
};
export var sortWrapperDesc = {
    ':after': __assign(__assign({}, getIcon(icons.down, 16, '#666666')), { content: '""', cursor: 'pointer', marginBottom: -2, marginLeft: 8 }),
};
export var sortWrapperDescDisabled = {
    ':after': __assign(__assign(__assign({}, sortWrapperDesc[':after']), getIcon(icons.down, 16, '#cccccc')), { cursor: 'not-allowed' }),
};
export var table = {
    borderBottom: '1px solid #cccccc',
    borderCollapse: 'separate',
    borderSpacing: 0,
    boxSizing: 'border-box',
    display: 'table',
    margin: 0,
    padding: 0,
    width: '100%',
};
export var td = {
    borderTop: '1px solid #cccccc',
    display: 'table-cell',
    padding: 8,
    position: 'relative',
    verticalAlign: 'middle',
    height: '100%',
};
export var tdThCheckbox = {
    whiteSpace: 'nowrap',
    width: 48,
    minWidth: 48,
    'input + *': {
        display: 'inline-block',
        marginLeft: 16,
    },
    '> *': {
        verticalAlign: 'middle',
    },
};
export var tdToggleExpanded = __assign(__assign({}, td), { width: 20, ':before': __assign(__assign({}, getIcon(icons.up, 20, '#ffffff')), { content: '""', cursor: 'pointer' }), ':hover': {
        cursor: 'pointer',
    }, ':hover:before': __assign(__assign({}, getIcon(icons.up, 20, 'rgba(255, 255, 255, 0.8)')), { content: '""', cursor: 'pointer' }) });
export var tdToggleNotExpanded = __assign(__assign({}, td), { width: 20, ':before': __assign(__assign({}, getIcon(icons.down, 20, '#1588af')), { content: '""', cursor: 'pointer' }), ':hover': {
        cursor: 'pointer',
    }, ':hover:before': __assign(__assign({}, getIcon(icons.down, 20, '#41a8d2')), { content: '""', cursor: 'pointer' }) });
export var tdToggleDisabled = __assign(__assign({}, tdToggleNotExpanded), { width: 20, ':before': __assign(__assign({}, getIcon(icons.down, 20, '#cccccc')), { content: '""', cursor: 'not-allowed' }) });
export var textDisabled = {
    color: "".concat('#cccccc', " !important"),
};
export var th = {
    background: '#ffffff',
    borderTop: '1px solid #cccccc',
    color: '#666666',
    display: 'table-cell',
    fontWeight: '700',
    margin: 0,
    padding: 8,
    textAlign: 'left',
    verticalAlign: 'bottom',
};
export var thSortable = __assign(__assign({}, th), { cursor: 'pointer' });
export var thDisabled = __assign(__assign({}, th), { color: "".concat('#cccccc', " !important"), cursor: 'not-allowed' });
export var thGroup = {
    backgroundColor: '#f5f5f5',
    borderRight: '2px solid #cccccc',
    borderTop: '1px solid #cccccc',
    textAlign: 'center',
    ':last-of-type': {
        borderRight: 'unset',
    },
};
export var thGroups = {
    backgroundColor: '#f5f5f5',
    height: 36,
};
export var tr = {
    display: 'table-row',
    verticalAlign: 'inherit',
    borderColor: 'inherit',
    td: {
        background: '#ffffff',
    },
};
export var trError = __assign(__assign({}, tr), { td: {
        background: '#f8e4e4',
    } });
export var trWarning = __assign(__assign({}, tr), { td: (_c = {
            background: '#ffe7c4'
        },
        _c[WARNING_ICONS.reduce(function (accumulator, icon) { return "".concat(accumulator, ", [class*=\"icon-").concat(icon, "\"]"); }, '').substring(2)] = {
            color: '#ab2811' + ' !important',
        },
        _c) });
export var trExpanded = __assign(__assign({}, tr), { color: "".concat('#ffffff', " !important"), td: {
        background: '#1588af',
    }, button: {
        '.pcty-icon': {
            color: '#ffffff',
        },
        ':hover .pcty-icon': {
            color: 'rgba(255, 255, 255, 0.8)',
        },
    }, a: {
        color: '#ffffff',
    } });
export var trHighlight = __assign({}, trExpanded);
export var trExpandedError = __assign(__assign({}, trExpanded), { td: {
        background: '#c8102e',
    } });
export var trExpansion = {
    td: {
        background: '#f5f5f5',
    },
};
export var trAlt = __assign(__assign({}, tr), { td: {
        background: '#eef9fb',
    } });
export var trDisabled = __assign(__assign({}, tr), { td: {
        background: "".concat('#ffffff'),
        '> *:not(input):not(button)': {
            filter: 'grayscale(1)',
            opacity: 0.2,
        },
    } });
export var trAltDisabled = __assign(__assign(__assign({}, trAlt), trDisabled), { td: {
        background: "".concat('#f5f5f5', " !important"),
        '> *:not(input):not(button)': {
            filter: 'grayscale(1)',
            opacity: 0.2,
        },
    } });
export var wrapper = {
    overflow: 'hidden',
    position: 'relative',
    ':before': {
        background: 'linear-gradient(to left, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%)',
        content: '""',
        display: 'block',
        height: '100%',
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        width: 12,
        zIndex: parseInt('700') + 1,
    },
    ':after': {
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 100%)',
        content: '""',
        display: 'block',
        height: '100%',
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
        width: 12,
        zIndex: parseInt('700') + 1,
    },
};
export var wrapperScrollEnd = {
    ':after': {
        opacity: '0 !important',
    },
};
export var wrapperFixedLeft = {
    ':before': {
        background: 'linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 100%)',
        content: '""',
        display: 'block',
        height: 'var(--container-height)',
        left: 'var(--first-columns-width)',
        marginTop: 1,
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        width: 12,
        zIndex: parseInt('700') + 1,
    },
};
export var headerFixedLeft = {
    position: 'sticky',
    left: 0,
    'z-index': parseInt('700') + 2 + ' !important',
};
export var fixedLeftBorder = {
    borderRight: '1px solid #cccccc',
};
export var columnFixedLeft = {
    position: 'sticky !important',
    left: 0,
    zIndex: parseInt('700') - 1,
};
export var wrapperFixedRight = {
    ':after': {
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 100%)',
        borderRight: '1px solid #cccccc',
        content: '""',
        display: 'block',
        height: 'var(--container-height)',
        marginTop: 1,
        pointerEvents: 'none',
        position: 'absolute',
        right: 'var(--last-columns-width)',
        top: 0,
        width: 12,
        zIndex: parseInt('700') + 1,
    },
};
export var headerFixedRight = {
    position: 'sticky',
    right: 0,
    'z-index': parseInt('700') + 2 + ' !important',
};
export var columnFixedRight = {
    position: 'sticky !important',
    right: 0,
    zIndex: parseInt('700') - 1,
};
export var fixedRightBorder = {
    borderLeft: '1px solid #cccccc',
};
export var wrapperScrollStart = {
    ':before': {
        opacity: '0 !important',
    },
};
export var wrapperContainer = {
    boxSizing: 'border-box',
    overflowX: 'auto',
    overflowScrolling: 'touch',
    width: '100%',
};
export var wrapperContainerScrollable = __assign(__assign({}, wrapperContainer), { maxHeight: 600, overflowY: 'auto', th: {
        position: 'sticky',
        top: 0,
        zIndex: parseInt('700'),
        ':after': {
            background: '#cccccc',
            bottom: '-1px',
            content: '""',
            display: 'block',
            position: 'absolute',
            height: 1,
            left: 0,
            width: '100%',
        },
    }, ':before': {
        background: 'linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0,0,0,0.1) 100%)',
        content: '""',
        display: 'block',
        height: 12,
        left: 0,
        marginBottom: '-12px',
        pointerEvents: 'none',
        position: 'absolute',
        top: 'var(--header-height)',
        width: 'var(--container-width)',
        zIndex: 700,
    }, ':after': {
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0,0,0,0.1) 100%)',
        bottom: 'var(--horizontal-scrollbar-height)',
        content: '""',
        display: 'block',
        height: 12,
        left: 0,
        marginTop: '-12px',
        pointerEvents: 'none',
        position: 'absolute',
        width: 'var(--container-width)',
        zIndex: 700,
    } });
export var wrapperContainerScrollEnd = {
    ':after': {
        opacity: '0 !important',
    },
};
export var wrapperContainerScrollStart = {
    ':before': {
        opacity: '0 !important',
    },
};
export var loadingContainer = {
    minHeight: 230,
    position: 'relative',
};
// Pager
export var pagerControl = {
    backgroundColor: 'transparent',
    border: 'none',
    alignItems: 'center',
    color: '#222222',
    cursor: 'pointer',
    display: 'inline-flex',
    height: 26,
    justifyContent: 'center',
    lineHeight: '26px',
    marginRight: 1,
    minWidth: 26,
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    verticalAlign: 'middle',
    ':focus': {
        ':after': {
            borderRadius: 2,
            bottom: -2,
            boxShadow: "0 0 0 2px ".concat('#085a7e'),
            content: '""',
            display: 'block',
            left: -2,
            pointerEvents: 'none',
            position: 'absolute',
            right: -2,
            top: -2,
            zIndex: 1,
        },
    },
    ':hover': {
        background: '#eaeaea',
        color: '#222222',
    },
};
export var pagerControlDisabled = __assign(__assign({}, pagerControl), { color: '#cccccc', cursor: 'not-allowed', ':hover': {
        background: 'unset',
        color: '#cccccc',
    } });
export var pagerLink = {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 2,
    color: '#666666',
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    minWidth: 10,
    padding: "0 ".concat(8, "px"),
    position: 'relative',
    textDecoration: 'none',
    ':focus': {
        ':after': {
            borderRadius: 2,
            bottom: -2,
            boxShadow: "0 0 0 2px ".concat('#085a7e'),
            content: '""',
            display: 'block',
            left: -2,
            pointerEvents: 'none',
            position: 'absolute',
            right: -2,
            top: -2,
            zIndex: 1,
        },
    },
    ':hover': {
        background: '#eaeaea',
        color: '#222222',
    },
};
export var pagerLinkDisabled = __assign(__assign({}, pagerLink), { color: '#cccccc', cursor: 'not-allowed', ':hover': {
        background: 'unset',
        color: '#cccccc',
    } });
export var pagerItem = {
    borderRadius: 2,
    display: 'inline-block',
    fontSize: 14,
    height: 26,
    lineHeight: '26px',
    marginRight: 1,
    minWidth: 10,
    textAlign: 'center',
    verticalAlign: 'middle',
};
export var pagerItemActive = __assign(__assign({}, pagerItem), { background: '#ff6611', color: '#ffffff', fontWeight: '700', padding: "0 ".concat(8, "px"), position: 'relative', ':hover': {
        background: '#ff6611',
        color: '#ffffff',
        cursor: 'default',
    }, ':focus': {
        ':after': {
            borderRadius: 2,
            bottom: -2,
            boxShadow: "0 0 0 2px ".concat('#085a7e'),
            content: '""',
            display: 'block',
            left: -2,
            pointerEvents: 'none',
            position: 'absolute',
            right: -2,
            top: -2,
            zIndex: 1,
        },
    } });
export var pagerItemDisabled = __assign(__assign({}, pagerItem), { ':hover': {
        background: 'unset',
        color: '#cccccc',
        cursor: 'not-allowed',
    } });
export var pagerList = {
    fontSize: 14,
    display: 'inline-block',
    lineHeight: 24 + 'px',
    margin: 0,
    padding: 0,
    verticalAlign: 'middle',
};
export var pagerRangeContainer = (_d = {
        display: 'inline-block',
        fontSize: 14,
        lineHeight: '26px',
        marginLeft: 8,
        verticalAlign: 'middle'
    },
    _d["@media ".concat(mobile(700))] = {
        display: 'block',
        marginTop: 8,
    },
    _d);
export var pagerRangeContainerDisabled = __assign(__assign({}, pagerRangeContainer), { color: '#cccccc', cursor: 'not-allowed' });
/** @ignore */
export var outlier = function (color) {
    var background, border;
    switch (color) {
        case 'yellow':
        default:
            background = '#ffe7c4';
            border = '#ea4810';
            break;
        case 'green':
            background = '#dcf9d9';
            border = '#1b815a';
            break;
        case 'red':
            background = '#f8e4e4';
            border = '#b20b29';
            break;
        case 'purple':
            background = '#f9f0ff';
            border = '#6f5aa0';
            break;
    }
    return {
        padding: 8,
        ':before': {
            boxSizing: 'border-box',
            content: '""',
            backgroundColor: background,
            border: '2px solid #cccccc',
            borderColor: border,
            borderRadius: 2,
            display: 'block',
            height: "calc(100% - ".concat(8 * 2, "px)"),
            margin: 8,
            position: 'absolute',
            left: 0,
            top: 0,
            width: "calc(100% - ".concat(8 * 2, "px)"),
        },
    };
};
export var outlierYellow = outlier('yellow');
export var outlierGreen = outlier('green');
export var outlierPurple = outlier('purple');
export var outlierRed = outlier('red');
export var outlierHover = {
    ':hover': {
        cursor: 'pointer',
    },
};
export var outlierContent = {
    position: 'relative',
    zIndex: 1,
};
/** @ignore */
export var outlierDetected = function (color) {
    var fontColor;
    switch (color) {
        case 'yellow':
        default:
            fontColor = '#ea4810';
            break;
        case 'green':
            fontColor = '#1b815a';
            break;
        case 'red':
            fontColor = '#b20b29';
            break;
        case 'purple':
            fontColor = '#6f5aa0';
            break;
    }
    return {
        color: fontColor,
        display: 'flex',
        fontSize: 12,
        fontWeight: '700',
        marginTop: 4,
        position: 'relative',
        zIndex: 1,
    };
};
export var outlierDetectedYellow = outlierDetected('yellow');
export var outlierDetectedGreen = outlierDetected('green');
export var outlierDetectedPurple = outlierDetected('purple');
export var outlierDetectedRed = outlierDetected('red');
export var outlierDetectedText = {
    marginLeft: 4,
};
export var outlierIcon = {
    marginRight: 4,
};
export var warningMessage = __assign(__assign({}, reset), { color: '#ab2811', display: 'block', fontSize: 12, paddingTop: 4 });
// Invalid Primary Key Error
export var invalidPrimaryKeyContainer = {
    alignItems: 'center',
    backgroundColor: '#f8e4e4',
    borderRadius: 2,
    boxShadow: 'unset',
    boxSizing: 'border-box',
    color: '#c8102e',
    display: 'flex',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '14px',
    marginBottom: 16,
    overflow: 'hidden',
    padding: 12,
    position: 'relative',
};
export var invalidPrimaryKeyIconContainer = {
    alignSelf: 'flex-start',
    display: 'flex',
    paddingRight: 12,
    paddingTop: 2,
};
export var invalidPrimaryKeyContentWrapper = {
    alignItems: 'flex-start',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
};
export var invalidPrimaryKeyMessage = {
    alignItems: 'flex-start',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    lineHeight: "".concat(20, "px"),
};
export var invalidPrimaryKeyTitle = {
    display: 'flex',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '4px',
    paddingRight: 12,
};
